import { render, staticRenderFns } from "./SectionAlertMain.vue?vue&type=template&id=31a82d38&"
import script from "./SectionAlertMain.vue?vue&type=script&lang=js&"
export * from "./SectionAlertMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports